import { ViewIds } from '@ardoq/api-types';
import { trackEvent } from 'tracking/tracking';
import { DataLimitProps } from './types';

export const trackShowingDataLimitWarning = (
  { canBypass, isEmpty, reducedDegrees, isAboveLimit }: DataLimitProps,
  activeView: ViewIds
) =>
  trackEvent('Triggered view data limit warning', {
    canBypass,
    isEmpty,
    reducedDegrees,
    isAboveLimit,
    activeView,
  });
